module.exports = __webpack_public_path__ + "img/3.7fdb9a66.jpg";